<div class="gjd-detail" *ngIf="jobData.getJob?.jobId != null">

  <!-- ===================== HERO ===================== -->
  <!-- Status pill pinned to the top-right of the hero (position: absolute in
       SCSS). When there's a posting employer, the logo+company-info row
       renders above the title; when there isn't, the row drops out entirely
       so the title becomes the first line and the status still sits cleanly
       in the top-right corner. -->
  <section class="gjd-hero">
    <span class="gjd-status" [ngClass]="'gjd-status--' + getStatusClass(jobData.getJob?.status)" role="status">
      {{ jobData.getJob?.status }}
    </span>

    <div class="gjd-company-row" *ngIf="jobData.getJob?.jobPostedBehalfOf">
      <div class="gjd-logo" aria-hidden="true">{{ getCompanyInitials() }}</div>
      <div class="gjd-company-info">
        <div class="gjd-company-name">
          {{ jobData.getJob?.jobPostedBehalfOf }}
          <svg *ngIf="jobData.getJob?.isFeatured" width="20" height="20" viewBox="0 0 24 24" aria-label="Featured employer" role="img">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        </div>
        <div class="gjd-company-location" *ngIf="getCompanyLocation()">{{ getCompanyLocation() }}</div>
      </div>
    </div>

    <h1 class="gjd-title">{{ jobData.getJob?.jobTitle }}</h1>

    <div class="gjd-meta-row">
      <span class="gjd-meta-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        Created {{ (jobData.getJob?.updatedOn | date:"MM/dd/yyyy") || '-' }}
      </span>
      <span class="gjd-meta-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" />
        </svg>
        <strong>{{ jobData.getJob?.jobReferenceId || '-' }}</strong>
      </span>
      <span class="gjd-meta-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
        </svg>
        <ng-container *ngIf="jobData.getJob?.city || jobData.getJob?.state || jobData.getJob?.country; else dashLoc">{{ jobData.getJob?.city }}<span *ngIf="jobData.getJob?.state">, {{ jobData.getJob?.state }}</span><span *ngIf="jobData.getJob?.country">, {{ jobData.getJob?.country }}</span></ng-container>
        <ng-template #dashLoc>-</ng-template>
      </span>
    </div>

    <div class="gjd-urgent-row" *ngIf="getActiveUrgencyDays(jobData.getJob) as urgencyDays">
      <span class="gjd-urgent-badge">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M13.5 0c.6 0 1.3 1.6 1.5 3 .3 1.8.1 3-1 4.3 1.5-.6 3-.5 4-.3 1.4.3 2.5 1.4 2.6 2.9.1 1.5-.8 2.7-2 3.1.8.7 1.4 1.7 1.4 3 0 2.8-3.1 5.2-7 5.2-3.5 0-7-2.2-7-5.7 0-1.8 1-3.5 2-4.7C7.8 9.6 7 8.4 7 6.7 7 4 9.7 1.8 13.5 0z"/>
        </svg>
        Urgent Hire
      </span>
      <span class="gjd-urgent-countdown">
        Urgency ends in {{ urgencyDays }} day{{ urgencyDays === 1 ? '' : 's' }}
      </span>
    </div>

    <div class="gjd-meta-row">
      <span class="gjd-meta-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
        <strong>{{ rateText || '-' }}</strong>
      </span>
    </div>

    <div class="gjd-sub-row">
      <span *ngIf="jobData.getJob?.showClientType">Position with {{ jobData.getJob?.clientType }}</span>
      <span *ngIf="jobData.getJob?.showClientName">· {{ jobData.getJob?.clientName }}</span>
      <span *ngIf="jobData.getJob?.jobClassification">· {{ jobData.getJob?.jobClassification }}</span>
    </div>

    <div class="gjd-badge-row">
      <span class="gjd-badge gjd-badge--purple" *ngIf="jobData.getJob?.workMode">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>
        {{ jobData.getJob?.workMode }}
      </span>
      <span class="gjd-badge gjd-badge--amber" *ngIf="jobData.getJob?.securityClearance">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
        Security Clearance
      </span>
      <span class="gjd-badge gjd-badge--gray" *ngIf="jobData.getJob?.experienceFrom != null || jobData.getJob?.experienceTo != null">
        {{ jobData.getJob?.experienceFrom }} – {{ jobData.getJob?.experienceTo }} yrs Experience
      </span>
      <span class="gjd-badge gjd-badge--blue" *ngIf="jobData.getJob?.jobClassification">
        {{ jobData.getJob?.jobClassification }}
      </span>
    </div>

    <hr class="gjd-hero-divider" aria-hidden="true">

    <div class="gjd-ctas">
      <a class="gjd-btn-apply"
         [class.gjd-disabled]="!jobData.getJob?.availability || jobData.getJob?.status != 'ACTIVE'"
         [target]="'_blank'" rel="noopener noreferrer" href="{{ getLoginParams(jobData.getJob) }}">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
        Apply Now
      </a>
      <button type="button" class="gjd-btn-icon" (click)="onSave()" aria-label="Save this job">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
        Save
      </button>
      <button type="button" class="gjd-btn-icon" (click)="onShare()" aria-label="Share this job">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>
        Share
      </button>
    </div>
  </section>

  <!-- ===================== JOB DETAILS ===================== -->
  <section class="gjd-section">
    <h2 class="gjd-section-title">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
      Job Details
    </h2>

    <dl class="gjd-grid">
      <div class="gjd-grid-item">
        <dt class="gjd-grid-label">Primary Skills</dt>
        <dd class="gjd-grid-value">
          <ng-container *ngIf="jobData.getJob?.primarySkills?.length; else dashPrimary">{{ jobData.getJob?.primarySkills?.join(', ') }}</ng-container>
          <ng-template #dashPrimary>—</ng-template>
        </dd>
      </div>
      <div class="gjd-grid-item">
        <dt class="gjd-grid-label">Secondary Skills</dt>
        <dd class="gjd-grid-value">
          <ng-container *ngIf="jobData.getJob?.secondarySkills?.length; else dashSecondary">{{ jobData.getJob?.secondarySkills?.join(', ') }}</ng-container>
          <ng-template #dashSecondary>—</ng-template>
        </dd>
      </div>
      <div class="gjd-grid-item">
        <dt class="gjd-grid-label">Experience</dt>
        <dd class="gjd-grid-value">
          <ng-container *ngIf="jobData.getJob?.experienceFrom != null || jobData.getJob?.experienceTo != null; else dashExp">
            {{ jobData.getJob?.experienceFrom ?? '-' }} to {{ jobData.getJob?.experienceTo ?? '-' }} years
          </ng-container>
          <ng-template #dashExp>-</ng-template>
        </dd>
      </div>
      <div class="gjd-grid-item">
        <dt class="gjd-grid-label">Education</dt>
        <!-- Placeholder — no field on the job model yet; wire to API later -->
        <dd class="gjd-grid-value gjd-placeholder">—</dd>
      </div>
      <div class="gjd-grid-item">
        <dt class="gjd-grid-label">Work Mode</dt>
        <dd class="gjd-grid-value">{{ jobData.getJob?.workMode || '—' }}</dd>
      </div>
      <div class="gjd-grid-item">
        <dt class="gjd-grid-label">Engagement Type</dt>
        <dd class="gjd-grid-value">{{ jobData.getJob?.jobClassification || '—' }}</dd>
      </div>
    </dl>

    <ng-container *ngIf="jobData.getJob?.primarySkills?.length">
      <p class="gjd-skills-label">Primary Skills</p>
      <ul class="gjd-skills-wrap" aria-label="Primary skills">
        <li class="gjd-skill-chip" *ngFor="let item of jobData.getJob?.primarySkills" [title]="item">{{ item }}</li>
      </ul>
    </ng-container>

    <ng-container *ngIf="jobData.getJob?.secondarySkills?.length">
      <p class="gjd-skills-label">Secondary Skills</p>
      <ul class="gjd-skills-wrap" aria-label="Secondary skills">
        <li class="gjd-skill-chip" *ngFor="let item of jobData.getJob?.secondarySkills" [title]="item">{{ item }}</li>
      </ul>
    </ng-container>
  </section>

  <!-- ===================== JOB DESCRIPTION ===================== -->
  <section class="gjd-section">
    <h2 class="gjd-section-title">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
      Job Description
    </h2>
    <div class="gjd-content" [innerHTML]="jobData.getJob != null && jobData.getJob?.jobDescription"></div>
  </section>

  <!-- ===================== ABOUT THE COMPANY ===================== -->
  <!-- Hidden entirely when the job has no employer link (jobPostedBehalfOf empty) — -->
  <!-- otherwise the section would render an empty logo box and a blank name line.  -->
  <section class="gjd-section" *ngIf="jobData.getJob?.jobPostedBehalfOf">
    <h2 class="gjd-section-title">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>
      About the Company
    </h2>
    <div class="gjd-about">
      <div class="gjd-about-logo" aria-hidden="true">{{ getCompanyInitials() }}</div>
      <div class="gjd-about-body">
        <p class="gjd-about-name">{{ jobData.getJob?.jobPostedBehalfOf }}</p>
        <p class="gjd-about-sub">
          <span *ngIf="getOrgTypeLabel()">{{ getOrgTypeLabel() }}</span><span *ngIf="getOrgTypeLabel() && getCompanyLocation()"> · </span><span *ngIf="getCompanyLocation()">{{ getCompanyLocation() }}</span>
        </p>
        <!-- Wired to backend `companyAbout` (HTML). Falls back to placeholder when
             the backend has no business record / no `aboutCompany` text yet. -->
        <div class="gjd-content"
             *ngIf="jobData.getJob?.companyAbout; else aboutMissing"
             [innerHTML]="jobData.getJob?.companyAbout"></div>
        <ng-template #aboutMissing>
          <div class="gjd-content gjd-about-placeholder">
            <p>Company description will appear here once available.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </section>

</div>
